import { render } from "./PurchaseViewDialog.vue?vue&type=template&id=5f5d8c58"
import script from "./PurchaseViewDialog.vue?vue&type=script&lang=js"
export * from "./PurchaseViewDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__